import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VListItem,{staticClass:"mb-0 justify-space-between pl-3"},[_c(VListItemContent,[_c(VImg,{attrs:{"src":require('@/assets/tripalio-logo.png'),"min-width":"120","height":"44","contain":""}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }